import { useEffect, useRef } from 'react';

type EmptyFunc = (...args: any[]) => void;

// Pass null to `delay` to stop the interval
const useInterval = (callback: EmptyFunc, delay: number | null): void => {
    const savedCallback = useRef<EmptyFunc>();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const handler = (...args: any[]) => {
            if (savedCallback.current) savedCallback.current(...args);
        };

        if (delay !== null) {
            const id = setInterval(handler, delay);
            return () => clearInterval(id);
        }
        return () => {};
    }, [delay]);
};

export default useInterval;
